import { useQueryClient } from '@tanstack/react-query';
import { useApiQuery } from '../useApiQuery';
import { useApiMutation } from '../useApiMutation';
import { reportSettingsEndpoints } from '@/lib/api/endpoints';
import { reportSettingsKeys } from '@/lib/queryKeys';
import { apiGet, apiPatch, operationsClient } from '@/lib/api/client';

export type ReportSettingsTab =
  | 'defaults'
  | 'branding'
  | 'fieldWorkflow'
  | 'sharing'
  | 'signatures';

export function useReportSettings() {
  return useApiQuery({
    queryKey: reportSettingsKeys.all(),
    queryFn: async () => apiGet(operationsClient, reportSettingsEndpoints.all()),
    showErrorToast: false,
  });
}

export function useUpdateReportSettings() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: async ({
      tab,
      patch,
    }: {
      tab: ReportSettingsTab;
      patch: Record<string, unknown>;
    }) => apiPatch(operationsClient, reportSettingsEndpoints.tab(tab), patch),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: reportSettingsKeys.all() });
    },
  });
}
